module.exports = __webpack_public_path__ + "files/1e2baab910dc99b5c7653f91e9ca4ad2.png";